import { render, staticRenderFns } from "./soc-bar.vue?vue&type=template&id=243ede59&"
import script from "./soc-bar.vue?vue&type=script&lang=js&"
export * from "./soc-bar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports